export default "__VITE_ASSET__GCnB5rt9__"